import { HubApi } from '@scorewarrior/rubens_web_lib/lib/hub-api/hub-api';
import { HubApiBuilder } from '@scorewarrior/rubens_web_lib/lib/hub-api/hub-api-builder';
import { Url } from '../url';
import { getCurrentHubInstance } from '../../../constants/projectName';

let hubApi: HubApi|null = null;

export function getHubApi() {
    if (!hubApi) {
        hubApi = new HubApiBuilder(Url.getHubClientRestapiUrl(), Url.getHubClientRestapiUrl())
            .getForGame(getCurrentHubInstance());
    }
    return hubApi;
}
